import { IEntity } from '../types';
import { EntityService } from './EntityService';

interface GraphDataRequest {
    runtimeParams: Record<string, any>;
}

export class ZGraphDefnService extends EntityService<IEntity> {
    private zedxApiURL: string = process.env.REACT_APP_ZedX_Non_Odata_API!;

    constructor() {
        super(`/ZGraphDefns`);
    }

    public async getGraphData(shortname: string, runtimeParams?: Record<string, any>): Promise<any> {
        const endPoint: string = `${this.zedxApiURL}/ZGraphDefns/GetGraphData/${shortname}`;

        // send flat object
        const requestBody = runtimeParams || {};

        const response = await super.readAnyEndPointValueWithPost(endPoint, requestBody);
        return response;
    }



    public async getGraphData__old(shortname: string): Promise<any> {
        const endPoint: string = `${this.zedxApiURL}/ZGraphDefns/GetGraphData/${shortname}`;
        const data = await super.readAnyEndPointValue(endPoint);
        return data;
    }
}